import script from "./FundExtensionController.vue?vue&type=script&setup=true&lang=ts"
export * from "./FundExtensionController.vue?vue&type=script&setup=true&lang=ts"

import "./FundExtensionController.vue?vue&type=style&index=0&id=117ecdb0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117ecdb0"]])

export default __exports__